import React, { useState, useEffect, useContext } from 'react';
import {
    Toolbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Grid,
    Fab,
    Typography,
    Button
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

import SideMenu from '../../components/SideMenu';
import Input from '../../components/Input';
import Alert from '../../components/Alert';
import Popup from '../../components/Popup';

import api from '../../services/api';
import { PermissionsContext } from '../../providers/Permissions';
import { ListPageHeading, ListTableCard, listResultSubtitle } from '../../components/ListPageLayout';

export default function CustomInputList() {
    const classes = useStyles();

    const {
        PermissionWrapper,
        PermissionOneOfWrapper,
    } = useContext(PermissionsContext);

    const [customInputs, setCustomInputs] = useState([]);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(0);
    const [refresh, setRefresh] = useState(true)
    const [limit, setLimit] = useState(10);
    const [openDeletePopup, setOpenDeletePopup] = useState(false);

    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    const [isDeleting, setIsDeleting] = useState(false);
    const [deletingCustomInputId, setDeletingCustomInputId] = useState();
    const handleDelete = (id) => {
        console.log(id)
        setDeletingCustomInputId(id);
        setOpenDeletePopup(true);
    }

    const deleteCustomInput = async (id) => {
        console.log('entrou', deletingCustomInputId)
        try {
            setIsDeleting(true);

            const result = await api.delete(`custom_input/delete/${deletingCustomInputId}`);

            const { success } = result.data;

            console.log(success);

            setIsDeleting(false);

            if (success) {
                setDeletingCustomInputId(null);
                setOpenDeletePopup(false);
                setRefresh(!refresh);
                setMessage({
                    open: true,
                    variant: 'success',
                    text: `Campo deletado com sucesso!`,
                });
            }
        } catch (err) {
            setIsDeleting(false);
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    }

    useEffect(() => {
        const loadData = async () => {
            try {
                const result = await api.get('/custom_input/list', {
                    params: {
                        search,
                        limit,
                        page,
                    },
                });

                console.log(search, limit, page)
                //console.log(result.data)

                const { count, custom_inputs } = result.data;

                console.log(custom_inputs);

                setCustomInputs(custom_inputs);
                setTotal(count);
            }
            catch (err) {
                console.log(err);
            }
        };

        loadData();
    }, [page, limit, search, refresh]);

    const changePage = (_, newPage) => {
        setPage(newPage);
    };

    const quantityPerPage = ({ target }) => {
        setLimit(parseInt(target.value, 10));
        setPage(0);
    };

    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <ListPageHeading icon="customInput" title="Lista de Campos Personalizados" />
                    </Grid>
                    
                    <Grid item xs={12}>
                        <div className={classes.tableWrapper}>
                            <ListTableCard
                                title="Campos personalizados cadastrados"
                                subtitle={listResultSubtitle(total)}
                                actions={(
<Input
                            icon={<SearchIcon style={{ color: grey[400] }} />}
                            iconPosition="start"
                            textFieldProps={{
                                placeholder: 'Buscar…',
                                onChange: ({ target }) => setSearch(target.value),
                            }}
                            className={classes.inputSearch}
                        />
                                )}
                            >
                                <TableContainer component={Paper}>
                                <Table className={classes.table} size="small" aria-label="access history">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHead}>ID</TableCell>
                                            <TableCell className={classes.tableHead}>Nome</TableCell>
                                            <TableCell className={classes.tableHead}>Descrição</TableCell>
                                            <TableCell className={classes.tableHead}>Formulário</TableCell>
                                            <TableCell className={classes.tableHead}>Obrigatoriedade</TableCell>
                                            <PermissionOneOfWrapper
                                                routes={[
                                                    "/custom_input/modificar/:id",
                                                    "/custom_input/deletar/:id",
                                                ]}
                                            >
                                                <TableCell className={classes.tableHead}>Ações</TableCell>
                                            </PermissionOneOfWrapper>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!!customInputs && customInputs.map(custom_input => (
                                            <TableRow key={custom_input.id}>
                                                <TableCell className={classes.tableBody} component="th" scope="row">
                                                    {custom_input.id}
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {custom_input.name}
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {custom_input.description}
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {
                                                        custom_input.type &&
                                                            custom_input.type === 'all' ? 'Regular e Visitante' :
                                                            custom_input.type === 'regular' ? 'Regular' :
                                                                custom_input.type === 'guest' ? 'Visitante' :
                                                                    custom_input.type === 'wanted' ? 'Procurado' :
                                                                        '-'
                                                    }
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {custom_input.is_required ? 'Sim' : 'Não'}
                                                </TableCell>
                                                <PermissionOneOfWrapper
                                                    routes={[
                                                        "/custom_input/modificar/:id",
                                                        "/custom_input/deletar/:id",
                                                    ]}
                                                >
                                                    <TableCell className={classes.tableBody}>
                                                        <>
                                                            <PermissionWrapper route="/custom_input/modificar/:id">
                                                                <Button
                                                                    type="button"
                                                                    size="small"
                                                                    color={"primary"}
                                                                    variant="contained"
                                                                    className={classes.actionButton}
                                                                    href={`/custom_input/modificar/${custom_input.id}`}
                                                                >
                                                                    <EditIcon style={{ fontSize: 20 }} />
                                                                </Button>
                                                            </PermissionWrapper>
                                                            <PermissionWrapper route="/custom_input/deletar/:id">
                                                                <Button
                                                                    type="button"
                                                                    size="small"
                                                                    color={"secondary"}
                                                                    variant="contained"
                                                                    className={classes.actionButton}
                                                                    onClick={() => handleDelete(custom_input.id)}
                                                                >
                                                                    <DeleteIcon style={{ fontSize: 20 }} />
                                                                </Button>
                                                            </PermissionWrapper>
                                                        </>
                                                    </TableCell>
                                                </PermissionOneOfWrapper>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            </ListTableCard>
                        </div>
                        <TablePagination
                            rowsPerPageOptions={[10, 20, 30]}
                            component="div"
                            count={total}
                            rowsPerPage={limit}
                            page={page}
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            labelRowsPerPage="Registros por página"
                            onChangePage={changePage}
                            onChangeRowsPerPage={quantityPerPage}
                        />
                    </Grid>
                    <Popup
                        openPopup={openDeletePopup}
                        setOpenPopup={setOpenDeletePopup}

                    >
                        <Grid container xs={12} style={{
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '0 3% 2% 3%',

                        }}>
                            <Typography variant='h5'
                                style={{
                                    fontWeight: 'bold',
                                    color: '#9e9e9e'
                                }}
                            >
                                Deseja mesmo deletar esse campo ?
                            </Typography>
                            <Grid item style={{
                                marginTop: '50px'
                            }}>
                                <Button
                                    disabled={isDeleting}
                                    variant="contained"
                                    onClick={() => deleteCustomInput()}
                                    color="secondary"
                                    endIcon={<DeleteIcon />}
                                >
                                    {isDeleting ? 'Deletando...' : 'Sim, delete o campo'}
                                </Button>
                            </Grid>

                        </Grid>
                    </Popup>
                </Grid>
                <PermissionWrapper route="/custom_input/criar">
                    <Fab
                        color="primary"
                        aria-label="add"
                        className={classes.fabButton}
                        href="/custom_input/criar"
                    >
                        <AddIcon />
                    </Fab>
                </PermissionWrapper>
                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}

            </main>
        </div>
    );


}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(5),
    },
    title: {
        color: 'rgba(6, 19, 31, 1)',
        fontSize: 28,
        fontWeight: 600,
    },
    inputSearch: {
        width: 340,
        maxWidth: '100%',
        '& .MuiTextField-root': {
            width: '100%',
        },
        '& .MuiOutlinedInput-root': {
            minHeight: 40,
            borderRadius:20,
            backgroundColor: '#f9fafb',
            transition: 'background-color 160ms ease, box-shadow 160ms ease',
            '&:hover': {
                backgroundColor: '#fff',
            },
            '&.Mui-focused': {
                backgroundColor: '#fff',
                boxShadow: '0 0 0 3px rgba(37, 99, 235, 0.10)',
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#dfe3e8',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    filterButton: {
        '&:hover': {
            backgroundColor: '#1e88e5',
            
        },
        borderRadius: 20,
        overflow: 'hidden',
    },
    tableWrapper: {
        borderRadius: 12,
        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        backgroundColor: '#fff',
    },
    table: {
        minWidth: 500,
        width: '100%',
    },
    tableHead: {
        borderBottom: '1px solid #e5e7eb',
        fontWeight: 700,
        textAlign: 'center',
        padding: '14px 10px',
        textTransform: 'uppercase',
        backgroundColor: '#f8fafc',
        color: '#64748b',
        letterSpacing: '0.06em',
        fontSize: 11,
        position: 'sticky',
        top: 0,
    },
    tableBody: {
        color: '#374151',
        padding: '14px 10px',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 600,
        borderBottom: '1px solid #eef1f5',
    },
    actionButton: {
        margin: theme.spacing(0, .5),
        padding: theme.spacing(.5, 0),
        minWidth: 30,
        borderRadius: 9,
    },
    editButton: {
        color: '#2563eb',
        backgroundColor: '#eff6ff',
        '&:hover': {
            backgroundColor: '#dbeafe',
        },
    },
    deleteButton: {
        color: '#dc2626',
        backgroundColor: '#fef2f2',
        '&:hover': {
            backgroundColor: '#fee2e2',
        },
    },
    fabButton: {
        position: 'fixed',
        bottom: 0,
        right: 0,
        margin: theme.spacing(3),
    },
}));
